import {Link} from 'react-router-dom';

function Topbar() {
  return (
    <>
      {' '}
      <div className="ltn__header-top-area border-bottom top-area-color-dark-blue">
        <div className="container">
          <div className="row">
            <div className="col-md-8 text-center ">
              <div className="ltn__top-bar-menu">
                <ul>
                  <li>
                    <Link
                      className="top-a"
                      to="mailto:info@webmail.com?Subject=Flower%20greetings%20to%20you"
                    >
                      <i className="icon-mail top-a"></i>{' '}
                      info@qualityhealth.org.uk
                    </Link>
                  </li>
                  <li>
                    <Link className="top-a" to="/contact">
                      <i className="icon-placeholder top-a"></i> 25 Port Street
                      Evesham WR11 3LD
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className=" text-center">
                <div className="ltn__top-bar-menu">
                  <ul>
                    <li>
                      {/* ltn__social-media */}
                      <div className="ltn__social-media">
                        <ul>
                          <li>
                            <Link className="top-a" to="#" title="Facebook">
                              <i className="fab fa-facebook-f"></i>
                            </Link>
                          </li>
                          <li>
                            <Link className="top-a" to="#" title="Twitter">
                              <i className="fab fa-twitter"></i>
                            </Link>
                          </li>

                          <li>
                            <Link className="top-a" to="#" title="Instagram">
                              <i className="fab fa-instagram"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Topbar;
